import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const Input = ({ field, formValues, onChange, dataTestid }) => {
  const intl = useIntl();
  const isPassword = field.inputType === 'password';
  // A password is hidden until the user asks to see it with the eye button.
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const toggleLabel = intl.formatMessage({
    id: isPasswordVisible ? 'hide_password' : 'show_password',
  });

  const passwordToggle = isPassword ? (
    <InputAdornment position="end">
      <IconButton
        aria-label={toggleLabel}
        title={toggleLabel}
        edge="end"
        size="small"
        onClick={() => setPasswordVisible((visible) => !visible)}
        onMouseDown={(event) => event.preventDefault()}
        data-testid={`${dataTestid}_visibility`}
      >
        {isPasswordVisible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
      </IconButton>
    </InputAdornment>
  ) : null;

  return (
    <Grid container item key={field.index} alignItems="center" sx={{ marginY: '20px' }}>
      <TextField
        fullWidth
        size="small"
        required={field.required}
        type={isPassword && !isPasswordVisible ? 'password' : 'text'}
        id={field.name}
        label={intl.formatMessage({ id: field.displayName })}
        name={field.name}
        placeholder={field.placeholder}
        value={formValues[field.name]}
        onChange={onChange}
        data-testid={dataTestid}
        inputProps={{ 'data-testid': dataTestid }}
        slotProps={passwordToggle ? { input: { endAdornment: passwordToggle } } : undefined}
      />
    </Grid>
  );
};

Input.defaultProps = {
  dataTestid: 'data_testid',
};

Input.propTypes = {
  field: PropTypes.object.isRequired,
  formValues: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  dataTestid: PropTypes.string,
};

export default Input;
